import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import PageHeader from '../../components/PageHeader/PageHeader';
import './ActivityDetail.css';

// Assets
import hortiImg from '../../assets/images/programs/horticulture/pic3.png';
import visitImg from '../../assets/images/programs/visit/pic.png';
import img4 from '../../assets/images/school/img4.png';
import maizeImg from '../../assets/images/programs/training/maize.png';
import img3 from '../../assets/images/school/img3.jpeg';
import coconutImg from '../../assets/images/programs/training/coconut.png';

const activitiesData: Record<string, any> = {
    "1": {
        title: "Excellence in Regenerative Agriculture Education",
        category: "AGRICULTURE",
        image: hortiImg,
        content: `
            <p>At Showbouys Foundation LBG, we believe that world-class knowledge is the key to transforming local communities. Our founder, <strong>Mr. Isaac Agyiri</strong>, recently marked a significant milestone in his professional journey that directly impacts our foundation's educational standards.</p>
            
            <p>Mr. Agyiri was distinguished as the <strong>Overall Best Agriculture Teacher of the Year</strong>, a prestigious recognition of his dedication to innovative teaching and sustainable farming practices. This award reflects the excellence we strive for in every training session we provide to our students.</p>

            <div class="highlight-box">
                "True education in agriculture isn't just about growing crops; it's about cultivating a mindset of sustainability and resilience for the next generation."
            </div>

            <h3>Advanced Expertise from the Netherlands</h3>
            <p>To further enhance our foundation's impact, Mr. Agyiri successfully completed a <strong>four-month specialized Horticulture training program in the Netherlands</strong>. Known globally for its cutting-edge greenhouse technology and efficient water management, the Netherlands provided a wealth of knowledge that we are now integrating into our local curriculum.</p>

            <h3>How this impacts our mission:</h3>
            <ul>
                <li><strong>Advanced Horticulture Techniques:</strong> We are introducing Dutch-inspired precision farming and greenhouse management to our local youth.</li>
                <li><strong>Regenerative Models:</strong> Merging traditional Ghanaian wisdom with international standards for soil health and biodiversity.</li>
                <li><strong>Certified Training:</strong> Our students now benefit from a curriculum informed by global best practices, preparing them for the competitive agribusiness landscape.</li>
            </ul>

            <p>By bringing this global expertise back home, Showbouys Foundation LBG is ensuring that our community remains at the forefront of agricultural innovation.</p>
        `
    },
    "2": {
        title: "Strategic Partnerships for Agricultural Transformation",
        category: "LEADERSHIP",
        image: visitImg,
        content: `
            <p>In a landmark move to align community-based efforts with national strategy, the leadership of Showbouys Foundation LBG paid a high-profile visit to <strong>Dr. Peter Otokunor</strong> at <strong>Flagstaff House</strong>.</p>
            <p>Dr. Otokunor, serving as the <strong>Director for Presidential Initiative for Agriculture and Agribusiness</strong>, engaged in extensive discussions with our team regarding the future of Ghanaian agriculture.</p>
            
            <div class="highlight-box">
                "Our goal is to bridge the gap between policy at the highest levels of government and practical implementation in our rural communities."
            </div>

            <h3>Key Discussion Areas</h3>
            <p>The meeting focused on several critical pillars for national growth:</p>
            <ul>
                <li><strong>Policy Integration:</strong> Aligning the Foundation's regenerative models with national agricultural frameworks.</li>
                <li><strong>Agribusiness Innovation:</strong> Creating value-chain opportunities for young entrepreneurs in the horticulture sector.</li>
                <li><strong>National Food Security:</strong> Scaling up community-led distribution networks to support urban and rural centers.</li>
            </ul>

            <p>This partnership marks a significant step toward systemic change, ensuring that the innovations developed at the grassroots level receive the institutional support needed for national impact.</p>
        `
    },
    "3": {
        title: "Hands-on Technical Training at Twifo Heman SHS",
        category: "EDUCATION",
        image: img4,
        content: `
            <p>Showbouys Foundation LBG is deeply committed to nurturing the next generation of agricultural professionals. In our latest educational outreach, we partnered with <strong>Twifo Heman Senior High Technical School</strong> to provide practical, hands-on training to their agricultural science students.</p>
            
            <p>The core focus of this session was the <strong>Nursing and Maintenance of Cabbage Nurseries on Beds</strong>. Moving beyond theoretical classroom learning, students were given the opportunity to engage directly with the soil and the life cycle of one of the region's most important vegetable crops.</p>

            <div class="highlight-box">
                "Technical education in agriculture is the backbone of food security. By teaching students proper nursery management, we are giving them a skill they can use to feed their families and build businesses."
            </div>

            <h3>What the Students Learned</h3>
            <ul>
                <li><strong>Bed Preparation:</strong> Proper soil aeration, leveling, and fertilization to create the ideal environment for delicate cabbage seeds.</li>
                <li><strong>Nursing Techniques:</strong> Precise seed placement and depth to ensure high germination rates.</li>
                <li><strong>Ongoing Maintenance:</strong> Scientific approaches to watering, shading, and pest prevention for young seedlings.</li>
                <li><strong>Nursery Management:</strong> Understanding the transition from nursery bed to transplanting for optimal crop yield.</li>
            </ul>

            <p>Through these practical sessions at Twifo Heman SHS, we are bridging the gap between academic knowledge and field expertise, ensuring these students leave school with marketable agribusiness skills.</p>
        `
    },
    "4": {
        title: "Advanced Maize Fertilization Techniques",
        category: "TRAINING",
        image: maizeImg,
        content: `
            <p>Maize is a staple of the Ghanaian diet and a cornerstone of national food security. At <strong>Hemang Senior High Technical School</strong>, Showbouys Foundation LBG conducted a specialized training session focused on maximizing maize yield through scientific fertilization methods.</p>
            
            <p>Understanding the 'Best Method of Application' is critical for ensuring that crops receive the nutrients they need while minimizing environmental runoff and cost waste. Our team worked directly with students to demonstrate precision application techniques.</p>

            <div class="highlight-box">
                "Effective fertilization is about precision, timing, and environmental care. We are training students to see agriculture as a science that requires both skill and strategic thinking."
            </div>

            <h3>Key Learning Outcomes</h3>
            <ul>
                <li><strong>Soil Nutrient Analysis:</strong> Teaching students how to identify nutrient deficiencies in maize plants before application.</li>
                <li><strong>Placement Methods:</strong> Side-dressing and banding techniques to ensure fertilizer reaches the root zone efficiently.</li>
                <li><strong>Timing and Dosage:</strong> Understanding the critical growth stages of maize and applying the correct amount of nutrients at the right time.</li>
                <li><strong>Sustainability:</strong> Reducing fertilizer waste to protect the surrounding soil and water sources.</li>
            </ul>

            <p>By empowering the students of Hemang SHS with these technical skills, we are helping them transform traditional farming into a modern, productive agribusiness venture.</p>
        `
    },
    "5": {
        title: "Community Spirit: Transplanting at Nduaem D/A Basic School",
        category: "COMMUNITY",
        image: img3,
        content: `
            <p>At Showbouys Foundation LBG, we believe that the best way to teach agriculture is to get your hands dirty. Recently, we had the immense pleasure of visiting <strong>Nduaem D/A Basic School Farm</strong> for a day of active learning and community impact.</p>
            
            <p>Led by our Founder & CEO, <strong>Mr. Isaac Agyiri</strong>, our team worked side-by-side with the students to transplant healthy cabbage seedlings from their nursery beds to the main field. It was more than just a farm task; it was a demonstration of teamwork and the joy of seeing your hard work grow.</p>

            <div class="highlight-box">
                "Seeing the excitement in the eyes of these young students as they handle their own seedlings is exactly why we do this work. We are planting seeds for their future careers."
            </div>

            <h3>Highlights of the Day</h3>
            <ul>
                <li><strong>Hands-on Learning:</strong> Students were taught the delicate process of handling seedlings to ensure root integrity during transplanting.</li>
                <li><strong>Teamwork in Action:</strong> The entire school farm came alive as students collaborated in rows, ensuring each seedling was perfectly spaced and watered.</li>
                <li><strong>Mentorship:</strong> Mr. Agyiri shared his experiences and encouraged the children to see agriculture as a path to empowerment and success.</li>
                <li><strong>Environmental Awareness:</strong> A discussion on the importance of soil care and water conservation in ensuring a healthy harvest.</li>
            </ul>

            <p>The day at Nduaem D/A Basic School Farm was a resounding success, leaving both our team and the students inspired by the power of collective effort and agricultural education.</p>
        `
    },
    "6": {
        title: "The Green Legacy: Understanding Afforestation",
        category: "ENVIRONMENT",
        image: coconutImg,
        content: `
            <p>At Showbouys Foundation LBG, our commitment to the planet goes beyond farming; it extends to the very air we breathe and the ecosystems that sustain us. Our latest environmental initiative focuses on <strong>Afforestation</strong>—the practice of planting trees to create new forests.</p>
            
            <p>We recently conducted a specialized session for students, teaching them about the vital role trees play in our environment. From carbon sequestration to soil protection, the benefits of afforestation are essential for a sustainable future.</p>

            <div class="highlight-box">
                "Planting a tree is an act of hope for the future. By teaching students about afforestation, we are ensuring that the leaders of tomorrow understand the value of our natural heritage."
            </div>

            <h3>The Importance of Afforestation</h3>
            <p>During our training, we highlighted several key reasons why afforestation is critical for our region:</p>
            <ul>
                <li><strong>Climate Change Mitigation:</strong> Trees act as natural carbon sinks, absorbing CO2 and helping to regulate the local climate.</li>
                <li><strong>Soil Protection:</strong> Tree roots stabilize the soil, preventing erosion and maintaining the fertility needed for agriculture.</li>
                <li><strong>Biodiversity Support:</strong> Creating new forest areas provides habitats for a wide range of local wildlife and plant species.</li>
                <li><strong>Water Cycle Regulation:</strong> Forests play a crucial role in maintaining local water tables and ensuring reliable rainfall patterns.</li>
            </ul>

            <p>Through these educational sessions, Showbouys Foundation LBG is empowering students to take active roles in environmental stewardship, ensuring a greener and more resilient planet for all.</p>
        `
    }
};

const ActivityDetail: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const activity = activitiesData[id || "1"];

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [id]);

    if (!activity) {
        return (
            <div className="activity-not-found">
                <Navbar />
                <div className="container py-5 text-center">
                    <h2>Activity Not Found</h2>
                    <Link to="/" className="btn btn-custom mt-3">Back to Home</Link>
                </div>
                <Footer />
            </div>
        );
    }

    return (
        <div className="activity-detail-page">
            <Navbar />
            <PageHeader 
                title={activity.title} 
                path="/activity"
                name="Activity Detail"
                backgroundImage={activity.image}
            />
            
            <div className="activity-content-section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="activity-card-detail">
                                <div className="activity-meta">
                                    <span className="activity-badge">{activity.category}</span>
                                    <span className="activity-date">MAY 2024</span>
                                </div>
                                
                                <div className="activity-body-text" dangerouslySetInnerHTML={{ __html: activity.content }}></div>
                                
                                <div className="activity-footer-nav mt-5 pt-4 border-top">
                                    <Link to="/" className="back-link">
                                        <i className="fas fa-arrow-left mr-2"></i> Back to Activities
                                    </Link>
                                    <div className="share-links">
                                        <span>Share this:</span>
                                        <button className="share-btn"><i className="fab fa-facebook-f"></i></button>
                                        <button className="share-btn"><i className="fab fa-twitter"></i></button>
                                        <button className="share-btn"><i className="fab fa-linkedin-in"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <Footer />
        </div>
    );
};

export default ActivityDetail;
